import { useEffect, useRef } from "react";
import { AiAssistantWrapper, PowerByShader } from "./AiAssistant.styled";

interface AiAssistantProps {

}

let AiAssistant: React.FC<AiAssistantProps> = (props)=> {
    // ref
    let iframeRef = useRef<HTMLIFrameElement>(null);

    // effect
    useEffect(()=> {
        let hideLogoTask = window.setInterval(()=> {
            let iframe = iframeRef.current;
            if (!iframe) {
                return;
            }

            let powerBy = iframe.contentDocument?.querySelector('body > div > div > div > div.flex.h-14.shrink-0.items-center.justify-end.p-3 > div > div > div > div') as HTMLElement;
            let logo = iframe.contentDocument?.querySelector('body > div > div > div > div.flex.h-14.shrink-0.items-center.justify-end.p-3 > div > div > div > img') as HTMLElement;
            if (logo) {
                logo.style.opacity = '0';
            }
            if (powerBy) {
                powerBy.style.opacity = '0';
            }
        }, 50);

        return ()=> {
            window.clearInterval(hideLogoTask);
        };
    }, []);

    // render
    return <AiAssistantWrapper>
        <PowerByShader />
        <iframe
            ref={(iframeElement)=> iframeRef.current = iframeElement}
            src="https://winch.intcon-sys.com:7083/chatbot/e27gY79GdMKLpqFW"
            style={{
                width: '100%',
                height: '100%',
                minHeight: '700px',
                border: 'none',
            }}
            allow="microphone">
        </iframe>
    </AiAssistantWrapper>
};

export default AiAssistant;
